import {TaxiMessage} from "./taxi-message";

export class TaxiNewSearch implements TaxiMessage {
  constructor(public draftId: number) {}

  getDraftId(): number {
    return this.draftId;
  }
}
